import { Input as ChakraInput, Field, FieldLabelProps, InputProps, VisuallyHidden } from "@chakra-ui/react";
import React, { RefObject } from "react";

interface Props extends InputProps {
  label: string;
  hideLabel?: boolean;
  labelProps?: FieldLabelProps;
  helperText?: string;
  errorMessage?: string;
  ref?: RefObject<HTMLInputElement | null>;
}

/**
 * Creating custom input-component to make sure label is always set (for accessibility)
 * Also handles some common needs (helper text and error message. For more advanced input-components we leave it to the consumers to compose custom input-components based on Chakra
 */
export const InputBS = (props: Props) => {
  const { labelProps, label, helperText, errorMessage, hideLabel, ...inputProps } = props;

  const formLabel = <Field.Label {...labelProps}>{label}</Field.Label>;

  return (
    <Field.Root invalid={!!errorMessage}>
      {hideLabel ? <VisuallyHidden>{formLabel}</VisuallyHidden> : formLabel}
      {helperText && <Field.HelperText>{helperText}</Field.HelperText>}
      <ChakraInput {...inputProps} />
      {errorMessage && <Field.ErrorText>{errorMessage}</Field.ErrorText>}
    </Field.Root>
  );
};
